<script>
export default {
  name: "SubPage"
}
</script>

<template>
  <router-view />
</template>

<style scoped lang="scss">

</style>
